module.exports = __webpack_public_path__ + "img/bud-right.7eb62599.svg";